import React, {
    useState,
    useEffect,
    useRef,
    useCallback,
} from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";

// helpers/services in your project
import { authHeader } from "_helpers";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Collapse, Modal, ModalBody } from "reactstrap";

// core components (match your project structure)
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import SignatureCanvas from "react-signature-canvas";
import { Rnd } from "react-rnd";

import "react-datetime/css/react-datetime.css";
import "./custom-style.css";

// pdf.js
import * as pdfjsLib from "pdfjs-dist/build/pdf";
// VERY IMPORTANT: ต้องคัดลอก node_modules/pdfjs-dist/build/pdf.worker.min.js → public/pdf.worker.min.js
pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

var currentUser = JSON.parse(localStorage.getItem('currentUser'));
// -------------------- Styles --------------------
const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: 0,
        fontSize: "14px",
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: 0,
        minHeight: "auto",
        fontWeight: 300,
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none",
    },
    cardTitleCustom: {
        background: "linear-gradient(to right, #2193b0, #6dd5ed)",
        margin: "-20px 15px 15px 15px",
    },
};
const useStyles = makeStyles(styles);

// -------------------- Modal วาดลายเซ็น --------------------
const SignPadModal = ({ open, onClose, onSave }) => {
    const sigRef = useRef(null);

    function handleClear() {
        if (sigRef.current) sigRef.current.clear();
    }

    /*
    function handleDone() {
        if (!sigRef.current || sigRef.current.isEmpty()) {
            alert("กรุณาเซ็นก่อน");
            return;
        }
        const dataUrl = sigRef.current
            .getTrimmedCanvas()
            .toDataURL("image/png");
        onSave(dataUrl);
    }
    */

    function handleDone() {
        if (!sigRef.current || sigRef.current.isEmpty()) {
            alert("กรุณาเซ็นก่อน");
            return;
        }
        // ดึง Canvas ที่ตัดขอบขาวแล้ว
        const trimmedCanvas = sigRef.current.getTrimmedCanvas();

        // ได้ Data URL
        const dataUrl = trimmedCanvas.toDataURL("image/png");

        // *** ส่งขนาดจริงของลายเซ็นออกไปพร้อม dataUrl ***
        const dimensions = {
            width: trimmedCanvas.width,
            height: trimmedCanvas.height
        };

        onSave(dataUrl, dimensions);
    }

    return (
        <Modal isOpen={open} toggle={onClose}>
            <div className="modal-header justify-content-center">
                <h4>โปรดลงลายมือชื่อ</h4>
            </div>
            <ModalBody>
                <div
                    style={{
                        border: "1px solid #999",
                        borderRadius: 8,
                        background: "#fff",
                    }}
                >
                    <SignatureCanvas
                        ref={sigRef}
                        penColor="blue"
                        minWidth={0.75}   // เส้นบางสุด (ตวัดเร็ว)
                        maxWidth={1.0}   // เส้นหนาสุด (ลากช้า) -- ค่าปกติคือ 2.5 (ลองลดเหลือ 1.0 หรือ 1.5)
                        canvasProps={{
                            width: 500,
                            height: 200,
                            style: {
                                height: "200px",
                                borderRadius: "8px",
                            },
                        }}
                    />
                </div>

                <div
                    style={{
                        marginTop: 10,
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 8,
                        justifyContent: "center",
                    }}
                >
                    <Button color="warning" onClick={handleClear}>
                        ลบ
                    </Button>
                    <Button color="success" onClick={handleDone}>
                        บันทึกลายเซ็น
                    </Button>
                    <Button color="danger" onClick={onClose}>
                        ยกเลิก
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

// -------------------- กล่องลายเซ็น draggable/resize --------------------
// box = { xPx, yPx, wPx, hPx } เป็นหน่วย "พิกเซลของหน้ากระดาษจริงที่เราวาดลง canvas"
// scaleX/scaleY = สเกลจริงจาก DOM (หลังถูก transform: scale(...))
//const SignatureBox = ({ signatureDataUrl, box, onChange, scaleX, scaleY }) => {
const SignatureBox = ({ signatureDataUrl, box, onChange, scaleX, scaleY, ratio }) => {
    const scaledSize = {
        width: box.wPx * scaleX,
        height: box.hPx * scaleY,
    };

    const scaledPos = {
        x: box.xPx * scaleX,
        y: box.yPx * scaleY,
    };

    return (
        <Rnd
            bounds="parent"
            size={scaledSize}
            position={scaledPos}
            onDragStop={(e, d) => {
                onChange({
                    ...box,
                    xPx: d.x / scaleX,
                    yPx: d.y / scaleY,
                });
            }}
            onResizeStop={(e, direction, ref, delta, position) => {
                onChange({
                    xPx: position.x / scaleX,
                    yPx: position.y / scaleY,
                    wPx: parseFloat(ref.style.width) / scaleX,
                    hPx: parseFloat(ref.style.height) / scaleY,
                });
            }}
            style={{
                border: "1px dashed #444",
                backgroundColor: "rgba(255,255,255,0.15)",
                cursor: "move",
                borderRadius: "4px",
                boxShadow: "0 4px 12px rgba(0,0,0,.2)",
                pointerEvents: "auto",
            }}
            lockAspectRatio={ratio || false} // <--- ล็อคสัดส่วนตามรูปจริง
        >
            <img
                src={signatureDataUrl}
                alt="signature"
                style={{
                    width: "100%",
                    height: "100%",
                    //objectFit: "contain",
                    objectFit: "fill", // <--- เปลี่ยนเป็น fill เพื่อให้ user เห็นเลยว่าถ้ายืดกล่อง รูปจะยืดตาม (WYSIWYG)
                    pointerEvents: "none",
                    userSelect: "none",
                }}
            />
        </Rnd>
    );
};

// -------------------- Main Component --------------------
const ESignInstance = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const user = useSelector((state) => state.auth.user);

    const { location } = props;
    const navState = location?.state || {};

    // 2. แตกตัวแปรตาม Code เดิมของคุณ (ใส่ Fallback value ไว้เผื่อ test)
    // หมายเหตุ: tableName, referenceName, rdlcPath รับมาจากหน้า List ที่เราส่งมา
    const templateId = navState.templateId || 0;
    const referenceKey = navState.referenceKey || 0;
    const clinicVisitKey = navState.clinicVisitKey || 0;
    // ตัวแปรอื่นๆ ที่ส่งมาด้วย
    const tableName = navState.tableName || "";
    const referenceName = navState.referenceName || "";
    const rdlcPath = navState.rdlcPath || "";
    const docName = navState.docName || "";
    const hn = navState.hn || "";
    const patientName = navState.patientName || "";


    // pageSizePt ใช้สำหรับ map พิกัด -> พิกัด pt ใน PDF
    const [pageSizePt, setPageSizePt] = useState(
        navState.pageSizePt || { width: 595.0, height: 842.0 } // fallback A4
    );

    // ไบต์ของ PDF (Uint8Array)
    const [pdfBytes, setPdfBytes] = useState(null);

    const [pdfBase64, setPdfBase64] = useState(null);
    // ขนาด bitmap จริงของหน้า PDF หลัง render ด้วย baseScale
    const [pageBitmapPx, setPageBitmapPx] = useState({
        width: 0,
        height: 0,
    });

    // scale ที่ใช้ "แสดงผล" ให้พอดีกับความกว้าง/ความสูง container (responsive)
    const [fitScale, setFitScale] = useState(1);

    // สเกลจริงจาก DOM (คำนวณจาก getBoundingClientRect เพื่อเลี่ยงการเพี้ยนเวลาไม่มี/มี scrollbar)
    const [domScale, setDomScale] = useState({ x: 1, y: 1 });

    // canvas จริง (เรนเดอร์ความละเอียดเต็ม)
    const canvasRef = useRef(null);

    // container ของ PDF viewer ที่เราจะใช้วัดความกว้าง/สูง
    const containerRef = useRef(null);

    // FRAME (outer) and LAYER (inner)
    const frameRef = useRef(null);
    // เลเยอร์ที่ถูกสเกลด้วยขนาดกล่อง (ไม่ใช้ CSS transform)
    const scaledLayerRef = useRef(null);

    // ลายเซ็น base64 (data URL)
    const [signatureDataUrl, setSignatureDataUrl] = useState(null);

    // กล่องลายเซ็น (ตำแหน่ง/ขนาดในหน่วย "bitmap จริง")
    const [sigBox, setSigBox] = useState({
        xPx: 100,
        yPx: 100,
        wPx: 200,
        hPx: 80,
    });

    const [sigRatio, setSigRatio] = useState(null);

    // modal states
    const [modal, setModal] = useState(false); // confirm apply signature
    const [modal2, setModal2] = useState(false); // success
    const [modalError, setModalError] = useState(false); // error
    const [modalCancel, setModalCancel] = useState(false); // cancel?
    const [errMsg, setErrMsg] = useState([]);
    const [icon, setIcon] = useState("far fa-question-circle");
    const [isOpen, setIsOpen] = useState(false);
    const [isShowList, setIsShowList] = useState(true);

    // modal เซ็นลายมือชื่อ
    const [showSignPadModal, setShowSignPadModal] = useState(false);
    // จำตำแหน่งที่ดับเบิลคลิก (ในหน่วย bitmap จริง ก่อนย่อ)
    const [pendingClickPos, setPendingClickPos] = useState(null);

    // moment/locale TH (ถ้าคุณใช้ตรงอื่น)
    const moment = require("moment");
    require("moment/locale/th");

    // -------------------- helper: base64 -> Uint8Array --------------------
    function base64PdfToUint8Array(pdfBase64) {
        const commaIndex = pdfBase64.indexOf(",");
        const pureBase64 =
            commaIndex >= 0 ? pdfBase64.substring(commaIndex + 1) : pdfBase64;
        const binaryString = atob(pureBase64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }

    // -------------------- โหลด PDF --------------------
    useEffect(() => {
        if (navState.pdfBytes && navState.pageSizePt) {
            setPdfBytes(navState.pdfBytes);
            setPageSizePt(navState.pageSizePt);
            return;
        }

        (async () => {
            try {
                const res = await axios.get("/api/v1/reportview/or", {
                    headers: authHeader(),
                    params: {
                        clinicVisitKey: clinicVisitKey,
                        templateId: templateId,
                        referenceKey: referenceKey,
                        creatorCodeName: currentUser.fullName,
                        rdlcPath: rdlcPath
                    },
                });


   

                const g = res?.data;
                if (!g) return;

                const bytes = base64PdfToUint8Array(g.pdfBase64);

                setPdfBase64(g.pdfBase64);
                setPdfBytes(bytes);

                if (g.pageSizePt?.width && g.pageSizePt?.height) {
                    setPageSizePt(g.pageSizePt);
                }
            } catch (err) {
                console.error(err);
            }
        })();
    }, [navState.pdfBytes, navState.pageSizePt]);

    // -------------------- เรนเดอร์ PDF ลง canvas (full quality) --------------------
    useEffect(() => {
        (async function renderPdf() {
            try {
                if (!pdfBytes || !canvasRef.current) return;

                const loadingTask = pdfjsLib.getDocument({ data: pdfBytes });
                const pdf = await loadingTask.promise;
                const page = await pdf.getPage(1);

                // baseScale: คุณภาพจริงของ canvas
                const baseScale = 1.5;
                const viewport = page.getViewport({ scale: baseScale });

                const canvas = canvasRef.current;
                const ctx = canvas.getContext("2d");

                canvas.width = viewport.width;
                canvas.height = viewport.height;

                setPageBitmapPx({
                    width: viewport.width,
                    height: viewport.height,
                });

                const renderContext = {
                    canvasContext: ctx,
                    viewport,
                };
                await page.render(renderContext).promise;
            } catch (err) {
                console.error("renderPdf error:", err);
            }
        })();
    }, [pdfBytes]);

    // -------------------- คำนวณ fitScale (ย่อ/ขยายตามความกว้าง container เท่านั้น) --------------------
    const recalcFitScale = useCallback(() => {
        if (!containerRef.current) return;
        if (!pageBitmapPx.width || !pageBitmapPx.height) return;
        const container = containerRef.current;
        const maxW = (container.clientWidth || 0) - 16;
        const scaleW = maxW / pageBitmapPx.width;
        const next = Math.min(scaleW, 1);
        setFitScale((prev) => (Math.abs(prev - next) > 1e-6 ? next : prev));
    }, [pageBitmapPx.width, pageBitmapPx.height]);

    // เรียกตอนรู้ขนาด pdf แล้ว + ตอบสนองการเปลี่ยนขนาดหน้าต่าง
    useEffect(() => {
        const handleResize = () => recalcFitScale();
        if (pageBitmapPx.width && pageBitmapPx.height) {
            recalcFitScale();
            window.addEventListener("resize", handleResize);
            window.addEventListener("orientationchange", handleResize);
        }
        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("orientationchange", handleResize);
        };
    }, [pageBitmapPx, recalcFitScale]);

    // ไม่ใช้ ResizeObserver กับ container เพื่อตัด loop จากการสเกล → ใช้เพียง window resize/orientationchange

    // -------------------- อัปเดต domScale จากขนาดจริงของ FRAME (เลี่ยง jitter/loop) --------------------
    const updateDomScale = useCallback(() => {
        if (!frameRef.current) return;
        const rect = frameRef.current.getBoundingClientRect();
        if (!pageBitmapPx.width || !pageBitmapPx.height) return;
        const nx = rect.width / pageBitmapPx.width;
        const ny = rect.height / pageBitmapPx.height;
        setDomScale((old) => (Math.abs(old.x - nx) > 1e-6 || Math.abs(old.y - ny) > 1e-6 ? { x: nx, y: ny } : old));
    }, [pageBitmapPx.width, pageBitmapPx.height]);

    useEffect(() => { updateDomScale(); }, [fitScale, pageBitmapPx.width, pageBitmapPx.height, updateDomScale]);

    // -------------------- ยืนยันตำแหน่งลายเซ็น -> ส่ง backend --------------------
    const handleConfirmSignature = async () => {
        // 1. Validation (เหมือนเดิม)
        if (!signatureDataUrl) {
            alert("กรุณาสร้างลายเซ็นก่อน");
            return;
        }
        if (!templateId) {
            alert("ไม่พบรหัสรายงาน (templateId)");
            return;
        }
        if (!pageBitmapPx.width || !pageBitmapPx.height) {
            alert("ยังไม่ทราบขนาดหน้ากระดาษ");
            return;
        }

        // 2. คำนวณพิกัด (เหมือนเดิม)
        const pdfWpt = pageSizePt.width;
        const pdfHpt = pageSizePt.height;
        const scaleX = pdfWpt / pageBitmapPx.width;
        const scaleY = pdfHpt / pageBitmapPx.height;

        const xPt = sigBox.xPx * scaleX;
        const wPt = sigBox.wPx * scaleX;
        const bottomPx = sigBox.yPx + sigBox.hPx;
        const pdfYBottomPx = pageBitmapPx.height - bottomPx;
        const yPt = pdfYBottomPx * scaleY;
        const hPt = sigBox.hPx * scaleY;

        // 3. เตรียม Body
        const body = {
            templateId,
            referenceKey,
            pdfBase64: pdfBase64,
            signatureImageBase64: signatureDataUrl,
            page: 1,
            x: xPt,
            y: yPt,
            width: wPt,
            height: hPt,
            ownerUserId: null,
        };

        // 4. เรียก API ด้วย Axios
        try {
            // เปิด Loading (ถ้ามี)
            setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
            setModal(true); // หรือ state loading อื่นๆ ของคุณ

            const res = await axios.post('/api/v1/reportview/apply-signature', body, {
                headers: {
                    ...authHeader(), // ใส่ Header Authen (ถ้ามี)
                    'Content-Type': 'application/json'
                }
            });

            const data = res.data; // Axios จะ parse JSON ให้อัตโนมัติ

            // 5. ตรวจสอบเงื่อนไข และ Redirect
            if (data.result === 200) {
                // ปิด Modal (ถ้าจำเป็น)
                setModal(false);

                // Redirect ไปยังหน้า consent/view/{ReferenceKey}
                // หมายเหตุ: ตรวจสอบตัวพิมพ์เล็ก/ใหญ่ (referenceKey vs ReferenceKey)
                // ว่า API ส่งกลับมาแบบไหน (ปกติ .NET Core จะแปลงเป็น camelCase ให้โดยอัตโนมัติ)
                //const refKey = data.referenceKey || data.ReferenceKey;
                //history.push(`/consent/view/${refKey}`);


                // ส่งค่าคืนกลับไป ใช้กรณี scan qr code และมาหน้าลงนามโดยตรง
                /*
                history.push({
                    pathname: "/consent/index", // กลับไป path หน้าตาราง
                });
                */
                history.goBack();

            } else {
                // กรณี result ไม่ใช่ 200
                alert("บันทึกไม่สำเร็จ: " + (data.msg || "Unknown error"));
                setIcon("far fa-question-circle");
            }

        } catch (err) {
            console.error("Error applying signature:", err);
            // Error Handling
            setIcon("far fa-question-circle");
            setModal(false);
            setErrMsg([
                err?.response?.data?.msg || err.message || "เกิดข้อผิดพลาดในการเชื่อมต่อ"
            ]);
            setModalError(true);
        }
    };

    const handleConfirmModalYes = async (evt) => {
        evt.preventDefault();
        await handleConfirmSignature();
    };

    return (
        <div className="pdf-sign-wrapper" style={{ margin: '-65px -30px 0 -30px'}} >
            <Grid>
                <Col
                    xs={12}
                    sm={12}
                    md={12}
                    style={{ display: isShowList ? "block" : "none" }}
                >
                    <Card>
                        <CardHeader color="primary">
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between", // ตัวสำคัญ: ผลักซ้าย-ขวา
                                    alignItems: "center",            // จัดให้อยู่กึ่งกลางแนวตั้ง
                                    flexWrap: "wrap",                // เผื่อหน้าจอเล็กให้ปุ่มตกลงมาได้
                                }}
                            >
                                {/* ส่วนซ้าย: ข้อความ */}
                                <h4 className={classes.cardTitleWhite} style={{ margin: 0 }}>
                                    ลงลายเซ็นบนเอกสาร
                                </h4>

                                {/* ส่วนขวา: กลุ่มปุ่ม */}
                                <div style={{ display: "flex", gap: 8 }}>
                                    <Button
                                        color="info"
                                        size="sm" // อาจจะพิจารณาใส่ size small ถ้าปุ่มใหญ่เกิน header
                                        onClick={() => {
                                            setShowSignPadModal(true);
                                        }}
                                    >
                                        {signatureDataUrl ? "แก้ไขลายเซ็น" : "สร้างลายเซ็น"}
                                    </Button>
                                    {signatureDataUrl ?
                                        <Button
                                            color="success"
                                            size="sm"
                                            onClick={() => {
                                                setModal(true);
                                            }}
                                        >
                                            ยืนยันตำแหน่งและบันทึก
                                        </Button>
                                        : <></>
                                    }
                                </div>
                            </div>
                        </CardHeader>

                        <CardBody>
                            {/* กรอบ responsive: ใช้ ref วัดขนาดเพื่อคำนวณ fitScale */}
                            <div
                                ref={containerRef}
                                style={{
                                    overflowY: "auto",
                                    //paddingRight: 8,
                                    maxHeight: "100%",//90vh",
                                }}
                            >
                                {/* FRAME ชั้นนอก: ขนาดหลังย่อจริง ทำให้ layout/scroll ถูกต้อง */}
                                <div
                                    ref={frameRef}
                                    style={{
                                        width: pageBitmapPx.width * fitScale,
                                        height: pageBitmapPx.height * fitScale,
                                        background: "#fff",
                                        boxShadow: "0 10px 30px rgba(0,0,0,.15)",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        position: "relative",
                                        margin: "0 auto",
                                    }}
                                >
                                    {/* LAYER ชั้นใน: ขนาดเต็มของ FRAME (ไม่ใช้ transform) */}
                                    <div
                                        ref={scaledLayerRef}
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            cursor: "crosshair",
                                        }}
                                        onDoubleClick={(e) => {
                                            if (!scaledLayerRef.current) return;
                                            const rect = scaledLayerRef.current.getBoundingClientRect();

                                            // คำนวณสเกลจริงจาก DOM (กัน offset ที่เพี้ยนเวลาไม่มี/มี scrollbar)
                                            const sX = rect.width / (pageBitmapPx.width || 1);
                                            const sY = rect.height / (pageBitmapPx.height || 1);

                                            const xReal = (e.clientX - rect.left) / sX;
                                            const yReal = (e.clientY - rect.top) / sY;

                                            setPendingClickPos({ x: xReal, y: yReal });

                                            const defaultW = 200;
                                            const defaultH = 80;
                                            if (!signatureDataUrl) {
                                                setShowSignPadModal(true);
                                            } else {
                                                setSigBox({
                                                    xPx: xReal - defaultW / 2,
                                                    yPx: yReal - defaultH / 2,
                                                    wPx: defaultW,
                                                    hPx: defaultH,
                                                });
                                            }
                                        }}
                                    >
                                        <canvas
                                            ref={canvasRef}
                                            style={{
                                                display: "block",
                                                background: "#fff",
                                                width: "100%",
                                                height: "100%",
                                            }}
                                        />

                                        {signatureDataUrl ? (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    pointerEvents: "none",
                                                }}
                                            >
                                                {/*
                                                <SignatureBox
                                                    signatureDataUrl={signatureDataUrl}
                                                    box={sigBox}
                                                    onChange={setSigBox}
                                                    scaleX={domScale.x}
                                                    scaleY={domScale.y}
                                                />
                                                */}
                                                <SignatureBox
                                                    signatureDataUrl={signatureDataUrl}
                                                    box={sigBox}
                                                    onChange={setSigBox}
                                                    scaleX={domScale.x}
                                                    scaleY={domScale.y}
                                                    ratio={sigRatio} // <--- ส่ง ratio เข้าไป
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>           
                        </CardBody>

                        <CardFooter />
                    </Card>
                </Col>
            </Grid>

            {/* ==== Modal วาดลายเซ็น ==== 
            <SignPadModal
                open={showSignPadModal}
                onClose={() => {
                    setShowSignPadModal(false);
                }}
                onSave={(dataUrl) => {
                    setSignatureDataUrl(dataUrl);
                    setShowSignPadModal(false);

                    if (pendingClickPos) {
                        const defaultW = 200;
                        const defaultH = 80;
                        setSigBox({
                            xPx: pendingClickPos.x - defaultW / 2,
                            yPx: pendingClickPos.y - defaultH / 2,
                            wPx: defaultW,
                            hPx: defaultH,
                        });
                        setPendingClickPos(null);
                    }
                }}
            />
            */}
            {/* แก้ไขการเรียกใช้ SignPadModal */}
            <SignPadModal
                open={showSignPadModal}
                onClose={() => setShowSignPadModal(false)}
                onSave={(dataUrl, dim) => { // รับ dim (dimensions) เข้ามา
                    setSignatureDataUrl(dataUrl);
                    setShowSignPadModal(false);

                    // คำนวณ Ratio
                    const ratio = dim.width / dim.height;
                    setSigRatio(ratio);

                    // กำหนดความสูงเริ่มต้นที่เหมาะสม (เช่น 60px หรือ 80px)
                    const defaultH = 80;
                    // คำนวณความกว้างตามสัดส่วนจริง
                    const defaultW = defaultH * ratio;

                    // ถ้าเป็นการ Double Click ให้ใช้ตำแหน่งที่คลิก
                    if (pendingClickPos) {
                        setSigBox({
                            xPx: pendingClickPos.x - defaultW / 2,
                            yPx: pendingClickPos.y - defaultH / 2,
                            wPx: defaultW,
                            hPx: defaultH,
                        });
                        setPendingClickPos(null);
                    } else {
                        // ถ้ากดปุ่มสร้างใหม่ ให้ reset กล่องไปที่ Default (หรือตำแหน่งเดิมแต่ปรับขนาด)
                        setSigBox((prev) => ({
                            ...prev,
                            wPx: defaultW,
                            hPx: defaultH
                        }));
                    }
                }}
            />

            {/* ====== Modals ยืนยัน / success / error ====== */}
            <CardFooter>
                <Collapse isOpen={isOpen}></Collapse>

                {/* Confirm apply signature */}
                <Modal toggle={() => setModal(false)} isOpen={modal}>
                    <div className="modal-header justify-content-center">
                        <div>
                            <i
                                className={icon}
                                style={{ color: "blue", fontSize: "2em" }}
                            ></i>
                        </div>
                    </div>
                    <ModalBody>
                        <p style={{ textAlign: "center", fontSize: "1.8em" }}>
                            {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                ? "ยืนยันการฝังลายเซ็นลงในเอกสาร?"
                                : "กำลังบันทึกตำแหน่งลายเซ็น..."}
                        </p>
                    </ModalBody>
                    <div className="modal-footer">
                        <Button
                            color="success"
                            type="button"
                            onClick={handleConfirmModalYes}
                            disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                        >
                            <i
                                className={"fa fa-thumbs-up"}
                                style={{
                                    fontSize: "1.8em",
                                    padding: "0 5px 5px 0",
                                }}
                            ></i>
                            <h4>ยืนยัน</h4>
                        </Button>
                        <Button
                            color="danger"
                            type="button"
                            onClick={() => {
                                setIcon("far fa-question-circle");
                                setModal(false);
                            }}
                        >
                            <i
                                className={"fa fa-thumbs-down"}
                                style={{
                                    fontSize: "1.8em",
                                    padding: "0 5px 5px 0",
                                }}
                            ></i>
                            <h4>ยกเลิก</h4>
                        </Button>
                    </div>
                </Modal>

                {/* Success */}
                <Modal isOpen={modal2}>
                    <div className="modal-header justify-content-center">
                        <div>
                            <i
                                className={"fas fa-check"}
                                style={{ color: "green", fontSize: "4em" }}
                            ></i>
                        </div>
                    </div>
                    <ModalBody>
                        <p
                            style={{
                                textAlign: "center",
                                fontSize: "1.8em",
                            }}
                        >
                            บันทึกการลงนามสำเร็จ
                        </p>
                    </ModalBody>
                    <div className="modal-footer">
                        <Button
                            color="info"
                            type="button"
                            onClick={() => {
                                history.goBack();
                            }}
                        >
                            <i
                                className={"fa fa-thumbs-up"}
                                style={{
                                    fontSize: "1.8em",
                                    padding: "0 5px 5px 0",
                                }}
                            ></i>
                            <h4>ตกลง</h4>
                        </Button>
                    </div>
                </Modal>

                {/* Error */}
                <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                    <div className="modal-header justify-content-center">
                        <div>
                            <i
                                className="fa fa-times"
                                style={{ color: "red", fontSize: "2em" }}
                            ></i>
                        </div>
                    </div>
                    <ModalBody>
                        <p>ไม่สามารถบันทึกการลงนามได้</p>
                        <div>{errMsg}</div>
                    </ModalBody>
                    <div className="modal-footer justify-content-center">
                        <Button
                            color="primary"
                            type="button"
                            onClick={() => setModalError(false)}
                        >
                            <h4>ตกลง</h4>
                        </Button>
                    </div>
                </Modal>

                {/* Optional: modalCancel */}
                <Modal toggle={() => setModalCancel(false)} isOpen={modalCancel}>
                    <div className="modal-header justify-content-center">
                        <div>
                            <i
                                className={icon}
                                style={{ color: "red", fontSize: "2em" }}
                            ></i>
                        </div>
                    </div>
                    <ModalBody>
                        <p
                            style={{
                                textAlign: "center",
                                fontSize: "1.8em",
                            }}
                        >
                            {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                ? "ปิดหน้าฟอร์มนี้หรือไม่?"
                                : "กำลังตรวจสอบข้อมูล"}
                        </p>
                    </ModalBody>
                    <div className="modal-footer">
                        <Button
                            color="success"
                            type="button"
                            onClick={() => {
                                setModalCancel(false);
                            }}
                            disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                        >
                            <i
                                className={"fa fa-thumbs-up"}
                                style={{
                                    fontSize: "1.8em",
                                    padding: "0 5px 5px 0",
                                }}
                            ></i>
                            <h4>ยืนยัน</h4>
                        </Button>
                        <Button
                            color="danger"
                            type="button"
                            onClick={() => {
                                setIcon("far fa-question-circle");
                                setModalCancel(false);
                            }}
                        >
                            <i
                                className={"fa fa-thumbs-down"}
                                style={{
                                    fontSize: "1.8em",
                                    padding: "0 5px 5px 0",
                                }}
                            ></i>
                            <h4>ปฏิเสธ</h4>
                        </Button>
                    </div>
                </Modal>
            </CardFooter>
        </div>
    );
};

export default ESignInstance;
